import { apiGet, apiPut } from '../client';
import { MembershipResponseSchema, type Membership } from '../schemas';
import type { BillingCycle, PlanTier } from '../../lib/plan';

export const MEMBERSHIP_QUERY_KEY = ['membership'];

export async function getMembership(): Promise<Membership> {
  const response = await apiGet('/v1/business/membership', MembershipResponseSchema);
  return response.data;
}

/**
 * Owner only. The negotiated discount carries over to the new plan server-side;
 * the cycle says whether it is paid month by month or the year up front.
 */
export async function changeMembershipPlan(plan: PlanTier, billingCycle: BillingCycle): Promise<Membership> {
  const response = await apiPut('/v1/business/membership', MembershipResponseSchema, { plan, billingCycle });
  return response.data;
}
